// State for event micro-site pages.

import { acceptHMRUpdate, defineStore } from 'pinia'

export const useEventPages = defineStore({
  id: 'eventPages',

  state: () => ({
    isLoading: true,
    eventValid: false,
    id: '',
    slug: '',
    endDate: '',
    startDate: '',
    title: '', // Title of the event
    description: '', // Long description of the event
    details: '',
    status: '',
    eventType: '',
    location: {
      address: '',
      geopoint: '',
      googleMapsLink: '',
      pluscode: ''
    },
    cartTheme: null, // TODO: Implement cart theming.
    tags: [],
    ticketTypes: [],
    ticketTypeCategories: [],
    termsLinkUrl: '#',
    privacyLinkUrl: '#',
    successReturnUrl: null,
    successReturnButtonText: 'Return to event website',
    cartStepsEnabled: false, // Enable to display cart breadcrumbs component.
    checkoutTimerEnabled: false // Enable to display checkout timer component.
  }),

  getters: {
    ticketTypesByDisplayCategory: (state) => {
      // Filter ticketTypes by displayCategory
      return displayCategory => state.ticketTypes.filter((t) => {
        if (t.displayCategory === displayCategory) {
          return t
        } else if (!t.displayCategory) {
          // If no displayCategory is set, set it to 'default'
          return { displayCategory: 'default', ...t }
        }
      })
    },
    ticketTypesWithoutDisplayCategory: (state) => {
      return state.ticketTypes.filter(t => !t.displayCategory)
    }
  },

  actions: {
    // Fetch tevent ticket types
    fetchEventSpec ({ tenantId, eventSlug }) {
      // TODO: fetchEventSpec  Not implemented until I can figure out how to use fetch in actions.
      this.isLoading = true
      console.log('fetchEventSpec() not yet implemented', { tenantId, eventSlug })
      this.isLoading = false
    },
    // Fetch tevent ticket types
    fetchEventTicketTypes () {
      // TODO: fetchEventTicketTypes Not implemented until I can figure out how to use fetch in actions.
      console.log('fetchEventTicketTypes() not yet implemented')
    }

  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEventPages, import.meta.hot))
}
